<template>
  <div class="c-no-result">
    <div class="no-result">
      <img
        class="no-result__img"
        src="/Themes/SoofiGashtV2/Apps/TourFilter/src/UI/Assets/Images/flightLoadingEarth.png"
        :alt="notFoundText"
      />

      <span class="no-result__title">
        متاسفانه تور مورد نظر یافت نشد
      </span>

      <span class="no-result__description">
        دوباره جستجو کنید یا فیلترها را تغییر دهید
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notFoundText: "یافت نشد",
    };
  },
  methods: {
    reLoad() {
      document.location.reload(true);
    },
  },
};
</script>
